// src/features/fourlink-config/utils/helpers/filters.js

export const isPlainObject = (value) => 
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const ensureArray = (value) => {
  if (Array.isArray(value)) return value;
  if (value === null || value === undefined) return [];
  return [value];
};

export const isMeaningful = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return false;
    const lowered = trimmed.toLowerCase();
    return lowered !== 'null' && lowered !== 'undefined' && lowered !== 'ninguno' && lowered !== 'ninguna';
  }
  if (Array.isArray(value)) {
    return value.some((item) => isMeaningful(item));
  }
  if (typeof value === 'object') {
    return Object.values(value).some((item) => isMeaningful(item));
  }
  return true;
};

export const normalizeValue = (raw) => {
  if (raw === null || raw === undefined) return undefined;

  if (typeof raw === 'number' || typeof raw === 'boolean') {
    return raw;
  }

  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return undefined;

    const lowered = trimmed.toLowerCase();
    if (lowered === 'null' || lowered === 'undefined') {
      return undefined;
    }

    if (/^[\[{].*[\]}]$/.test(trimmed)) {
      try {
        const parsed = JSON.parse(trimmed);
        const normalizedParsed = normalizeValue(parsed);
        if (isMeaningful(normalizedParsed)) {
          return normalizedParsed;
        }
      } catch (_) {
        // Si falla el parseo seguimos con el string original
      }
    }

    return trimmed;
  }

  if (Array.isArray(raw)) {
    const normalizedItems = raw
      .map((item) => normalizeValue(item))
      .filter((item) => item !== undefined && item !== null && !(typeof item === 'string' && item.trim() === ''))
      .map((item) => (typeof item === 'string' ? item : String(item)));

    if (normalizedItems.length === 0) return undefined;
    return normalizedItems.join(', ');
  }

  if (typeof raw === 'object') {
    const preferredKeys = ['nombre', 'name', 'titulo', 'descripcion', 'descripcion_larga', 'label', 'texto', 'valor', 'value'];

    for (const key of preferredKeys) {
      if (key in raw) {
        const candidate = normalizeValue(raw[key]);
        if (isMeaningful(candidate)) {
          return candidate;
        }
      }
    }

    const fallbackValues = Object.values(raw)
      .map((value) => normalizeValue(value))
      .filter((value) => value !== undefined && value !== null && !(typeof value === 'string' && value.trim() === ''));

    if (fallbackValues.length > 0) {
      return fallbackValues[0];
    }

    return undefined;
  }

  return undefined;
};

export const firstNonEmpty = (...candidates) => {
  for (const candidate of candidates) {
    const normalized = normalizeValue(candidate);
    if (normalized !== undefined && normalized !== null) {
      if (typeof normalized === 'string') {
        const trimmed = normalized.trim();
        if (trimmed) {
          return trimmed;
        }
      } else {
        return normalized;
      }
    }
  }
  return undefined;
};

export const isErrorLike = (s) => 
  typeof s === 'string' && /error|odbc|sql server|sintaxis incorrecta|sqlstate|exception|warning/i.test(s);